export const IsError = (error: unknown): error is Error => {
    return error instanceof Error;
};